import { FormItemProps, Radio, RadioGroupProps } from 'antd';
import { CheckboxOptionType } from 'antd/es/checkbox/Group';
import {
    RadioGroupButtonStyle,
    RadioGroupOptionType,
} from 'antd/es/radio/interface';
import { FormItem } from 'src/components/Form/FormItem';
import { CssColors } from 'src/styles/CssVariables';
import styled from 'styled-components';

export type RadioGroupFieldProps = FormItemProps & {
    disabled?: boolean;
    inputProps?: RadioGroupProps;
    options?: (CheckboxOptionType | string | number)[];
    optionType?: RadioGroupOptionType;
    buttonStyle?: RadioGroupButtonStyle;
};

export const RadioGroupField = ({
    disabled,
    inputProps,
    options,
    optionType,
    buttonStyle,
    ...props
}: RadioGroupFieldProps) => {
    return (
        <FormItem {...props}>
            <RadioGroupStyled
                options={options}
                disabled={disabled}
                optionType={optionType}
                buttonStyle={buttonStyle}
                {...inputProps}
            />
        </FormItem>
    );
};

const RadioGroupStyled = styled(Radio.Group)`
    .ant-radio-input:focus + .ant-radio-inner {
        box-shadow: 0 0 0 3px rgba(23, 23, 23, 0.12) !important;
    }

    .ant-radio-inner,
    .ant-radio-inner:focus,
    .ant-radio-inner:active,
    .ant-radio-inner:hover {
        border-color: ${CssColors.black} !important;
    }

    .ant-radio-inner::after,
    .ant-radio-checked::after {
        background-color: ${CssColors.black} !important;
    }
`;
